export const FETCH_ONE = 'notices/FETCH_ONE';
export const FETCH_ONE_SUCCESS = 'notices/FETCH_ONE_SUCCESS';
export const FETCH_COLLECTION = 'notices/FETCH_COLLECTION';
export const FETCH_COLLECTION_SUCCESS = 'notices/FETCH_COLLECTION_SUCCESS';
export const GET_FAVORITES = 'notices/GET_FAVORITES';
export const GET_FAVORITES_SUCCESS = 'notices/GET_FAVORITES_SUCCESS';
export const SAVE_FAVORITE = 'notices/SAVE_FAVORITE';
export const SAVE_FAVORITE_SUCCESS = 'notices/SAVE_FAVORITE_SUCCESS';
export const REMOVE_FAVORITE = 'notices/REMOVE_FAVORITE';
export const REMOVE_FAVORITE_SUCCESS = 'notices/REMOVE_FAVORITE_SUCCESS';
export const SAVE_READ_POST = 'notices/SAVE_READ_POST';
export const SAVE_READ_POST_SUCCESS = 'notices/SAVE_READ_POST_SUCCESS';
export const GET_READ_POSTS = 'notices/GET_READ_POSTS';
export const GET_READ_POSTS_SUCCESS = 'notices/GET_READ_POSTS_SUCCESS';
